/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type OnboardingContext =
    (typeof OnboardingContext)[keyof typeof OnboardingContext];

export const OnboardingContext = {
    CreateOrganisation: 'CreateOrganisation',
    JoinOrganisation: 'JoinOrganisation',
    AlreadyCompleted: 'AlreadyCompleted',
    Unavailable: 'Unavailable',
} as const;
